import fetch from '../utils/fetch'

export function getMemberPoint (query) {
  return fetch({
    url: '/point/member',
    method: 'get',
    params: query
  })
}

export function getNpPointSetting (query) {
    return fetch({
        url: '/setting/nppoint',
        method: 'get',
        params: query
    })
}

export function createNpPointSetting (query) {
    return fetch({
        url: '/setting/nppoint/create',
        method: 'put',
        params: query
    })
}

export function updateNpPointSetting (id, query) {
    return fetch({
        url: '/setting/nppoint/update/' + id,
        method: 'patch',
        params: query
    })
}


// WEBPACK FOOTER //
// ./src/api/point.js